<div class="skeleton" aria-hidden="true">
  <!-- Breadcrumb skeleton -->
  <div class="skeleton__breadcrumb">
    <div class="shimmer shimmer--text" style="width: 60px;"></div>
    <div class="shimmer shimmer--text" style="width: 120px;"></div>
    <div class="shimmer shimmer--text" style="width: 160px;"></div>
  </div>

  <!-- Two-column layout -->
  <div class="skeleton__columns">
    <!-- Left: gallery -->
    <div class="skeleton__gallery">
      <div class="shimmer skeleton__main-image"></div>
      <div class="skeleton__thumbs">
        <div class="shimmer skeleton__thumb"></div>
        <div class="shimmer skeleton__thumb"></div>
        <div class="shimmer skeleton__thumb"></div>
      </div>
    </div>

    <!-- Right: info -->
    <div class="skeleton__info">
      <div class="shimmer shimmer--badge" style="width: 60px;"></div>
      <div class="shimmer shimmer--heading" style="width: 85%;"></div>
      <div class="shimmer shimmer--text" style="width: 55%;"></div>
      <div class="shimmer shimmer--badge" style="width: 80px;"></div>
      <div class="shimmer shimmer--text" style="width: 40%;"></div>
      <div class="skeleton__info-spacer"></div>
      <div class="shimmer shimmer--price" style="width: 130px;"></div>
      <div class="shimmer shimmer--text" style="width: 100px;"></div>
      <div class="skeleton__info-spacer"></div>
      <div class="skeleton__qty-row">
        <div class="shimmer skeleton__qty-box"></div>
        <div class="shimmer skeleton__cta-box"></div>
      </div>
      <div class="skeleton__info-spacer"></div>
      <div class="shimmer shimmer--text" style="width: 70%;"></div>
      <div class="shimmer shimmer--text" style="width: 50%;"></div>
    </div>
  </div>

  <!-- Tabs skeleton -->
  <div class="skeleton__tabs">
    <div class="skeleton__tab-bar">
      <div class="shimmer shimmer--tab"></div>
      <div class="shimmer shimmer--tab"></div>
      <div class="shimmer shimmer--tab"></div>
    </div>
    <div class="skeleton__tab-content">
      <div class="shimmer shimmer--text" style="width: 100%;"></div>
      <div class="shimmer shimmer--text" style="width: 90%;"></div>
      <div class="shimmer shimmer--text" style="width: 75%;"></div>
      <div class="shimmer shimmer--text" style="width: 85%;"></div>
    </div>
  </div>

  <!-- Related products skeleton -->
  <div class="skeleton__related">
    <div class="shimmer shimmer--section-title" style="width: 200px;"></div>
    <div class="skeleton__carousel">
      @for (item of carouselSkeletons; track $index) {
        <app-product-card-skeleton />
      }
    </div>
  </div>
</div>
